import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { auth, firestore } from "./firebase";
import { doc, getDoc, query, where, getDocs, collection } from "firebase/firestore";
import "./TransferModal.css";
import Mone from "./assets/seopy.svg";
import BackArrow from "./assets/transferBack.svg";
import Plusam from "./assets/pluduihufaw.svg";
import EmailIcon from '../src/assets/emailShape.svg';
import Wrong from "./assets/Subtractgg.svg";
import Human from "./assets/UserIcon.svg";
import Emailer from "../src/assets/SignUpIcon/creditCard.svg";
import Receipt from "../src/assets/SignUpIcon/reciept.svg";
import FileMoney from "../src/assets/SignUpIcon/filesMoney.svg";
import Keyy from "../src/assets/SignUpIcon/key.svg";
import Verii from '../src/assets/SignUpIcon/veri.png';

const TransferModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const [recipientEmail, setRecipientEmail] = useState("");
  const [recipientUsername, setRecipientUsername] = useState(""); // New state for recipient username
  const [amount, setAmount] = useState("");
  const [description, setDescription] = useState("");
  const [userData, setUserData] = useState(null);
  const [walletBalance, setWalletBalance] = useState(0);
  const [loading, setLoading] = useState(true);
  const [inSufficient, setInsufficient] = useState(false);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const user = auth.currentUser;
        if (user) {
          const userDocRef = doc(firestore, "users", user.uid);
          const userDoc = await getDoc(userDocRef);
          if (userDoc.exists()) {
            const data = userDoc.data();
            setUserData(data);
            setWalletBalance(data.balance || 0);
          } else {
            console.error("No user data found for UID:", user.uid);
          }
        } else {
          console.error("No authenticated user found");
        }
      } catch (error) {
        console.error("Error fetching user data: ", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);

  const fetchRecipientUsername = async (email) => {
    try {
      const usersRef = collection(firestore, "users");
      const q = query(usersRef, where("email", "==", email));
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        const userDoc = querySnapshot.docs[0];
        const userData = userDoc.data();
        setRecipientUsername(userData.username);
      } else {
        setRecipientUsername("");
      }
    } catch (error) {
      console.error("Error fetching recipient username: ", error);
      setRecipientUsername("");
    }
  };

  const handleRecipientEmailChange = (e) => {
    const email = e.target.value;
    setRecipientEmail(email);
    fetchRecipientUsername(email);
  };

  const handleAmountChange = (e) => {
    const value = e.target.value.replace(/[^0-9.]/g, "");
    const [integerPart, decimalPart] = value.split(".");
    const formattedIntegerPart = integerPart ? parseInt(integerPart, 10).toLocaleString() : "";
    const formattedValue = decimalPart !== undefined ? `${formattedIntegerPart}.${decimalPart}` : formattedIntegerPart;
    setAmount(formattedValue);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const numericAmount = parseFloat(amount.replace(/,/g, ""));
    if (numericAmount > walletBalance) {
      setInsufficient(true);
      return;
    }

    const transferDetails = {
      recipientEmail,
      amount: numericAmount,
      description,
      title: `Transfer to ${recipientEmail}`,
      type: "expense",
      name: "Transfer"
    };

    navigate("/verify-pinn", { state: { transferDetails } });
  };

  if (!isOpen) return null;

  if (loading) {
    return (
      <div className="modal-overlay">
        <div className="loading">Loading...</div>
      </div>
    );
  }

  const closerModal = () => {
    setInsufficient(false);
  };

  return (
    <div className="modal-overlay">
      <div className="transferBar">
        <button className="circleTransfer" onClick={onClose}>
          <img style={{ width: 11 }} src={BackArrow} alt="" />
        </button>
        <p className="transfername">Transfer</p>
        <div className="circleTransfer none"></div>
      </div>
      <div className="transferBalance">
        <p className="balanceName">Available Balance</p>
        <h1 className="mybalance">
          ${parseFloat(walletBalance).toLocaleString()}
        </h1>
      </div>
      <div className="recentDivs">
        <p className="balanceNameblack">Send money to</p>
        <div className="transferBene">
          <div className="transferHolder">
            <div className="transferBeneCircle">
              <img style={{ width: 14 }} src={Plusam} alt="" />
            </div>
            <p className="balanceNameblack">Jeniffer</p>
          </div>
          <div className="transferHolder">
            <div className="transferBeneCircle"></div>
            <p className="balanceNameblack">Maya</p>
          </div>
          <div className="transferHolder">
            <div className="transferBeneCircle"></div>
            <p className="balanceNameblack">John</p>
          </div>
          <div className="transferHolder">
            <div className="transferBeneCircle">
              <img style={{ width: 11 }} src={BackArrow} alt="" />
            </div>
            <p className="balanceNameblack">Send</p>
          </div>
        </div>
      </div>
      <div className="drawerr"></div>
      <div className="modal-content">
        <form className="formTransfer" onSubmit={handleSubmit}>
          <div className="tran-inpu">
            <label>Recipient Email</label>
            <div className="transferAmount">
              <img className="transferIcon" src={EmailIcon} alt="" />
              <input
                style={{
                  padding: 7,
                  borderRadius: 0,
                  width: "90%",
                  alignItems: "flex-start",
                  display: "flex",
                  justifyContent: "flex-start",
                  gap: 10,
                  fontSize: 17,
                  fontWeight: '600'
                }}
                className="transINPU"
                type="email"
                value={recipientEmail}
                placeholder="user email"
                onChange={handleRecipientEmailChange}
                required
              />
            </div>
            {recipientUsername && (
              <div className="receivername">
                <p style={{borderWidth: 0, color: '#00000060'}} className="recipient-username">Receiver Name: </p>
                <p className="recipient-username">{recipientUsername} <img style={{width: 12,}} src={Verii} alt='verified user' /> </p>
                <p style={{borderWidth: 0, color: '#00000060', fontSize: 8,}} className="recipient-username">this user exist on this email </p>
              </div>
            )}
          </div>
          <div className="tran-inpu">
            <label className="upper">Amount</label>
            <div className="transferAmount">
              <p className="transferIcon">$</p>
              <input
                style={{
                  padding: 14,
                  borderRadius: 0,
                  width: "88%",
                  alignItems: "flex-start",
                  display: "flex",
                  justifyContent: "flex-start",
                  gap: 10,
                  fontSize: 26,
                  fontWeight: '800'
                }}
                className="transINPU"
                type="text"
                value={amount}
                onChange={handleAmountChange}
                required
                placeholder="Amount"
              />
            </div>
          </div>
          <div className="tran-inpu">
            <label>Description </label>
            <div className="transferAmount">
              <img style={{width: 26}} className="transferIcon" src={FileMoney} alt="" />
              <input
                style={{
                  padding: 13,
                  borderRadius: 0,
                  width: "90%",
                  alignItems: "flex-start",
                  display: "flex",
                  justifyContent: "flex-start",
                  gap: 10,
                  fontSize: 15,
                  fontWeight: '500'
                }}
                className="transINPU"
                type="text"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="transaction description"
                required
              />
            </div>
          </div>
          <div
            style={{
              paddingTop: 30,
              borderRadius: 17,
              width: "100%",
              alignItems: "center",
              display: "flex",
              justifyContent: "center",
              flexDirection: "row",
              gap: 10,
            }}
          >
            <button
              style={{
                padding: 17,
                borderRadius: 15,
                width: "100%",
                backgroundColor: '#000000'
              }}
              className="submit-button"
              type="submit"
            >
              Transfer Funds <img src={Mone} alt="icon" />
            </button>
          </div>
        </form>
      </div>
      {inSufficient && (
        <div className="inSufficientModal">
          <div className="inSufficientModalChild">
            <div className="noBalance">
              <img style={{width: 40}} src={Wrong} />
              <h2 style={{marginBottom: 0}}>Insufficient Funds</h2>
            </div>
            <div className="noBalance">
              <p style={{marginBottom: 5, textAlign: 'center', fontSize: 14}}>
                You don't have sufficient balance to complete this transaction, use the button below to add money to your account.
              </p>
            </div>
            <button onClick={() => alert('Adding Money Please wait.......')} className="addMoneyBtn">
              Add Money
            </button>
            <button className="cancelTransfer" onClick={closerModal}>
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TransferModal;
